module.exports = __webpack_public_path__ + "static/img/bg-ar.e7846401.png";